import { render, staticRenderFns } from "./centerReward.vue?vue&type=template&id=1b6be30e&scoped=true"
import script from "./centerReward.vue?vue&type=script&lang=js"
export * from "./centerReward.vue?vue&type=script&lang=js"
import style0 from "./centerReward.vue?vue&type=style&index=0&id=1b6be30e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6be30e",
  null
  
)

export default component.exports